import {
    CLOSE_MODAL
} from 'store/actionConsts';

export const closeModal = () => ({
    type: CLOSE_MODAL
});
